export default __webpack_public_path__ + "static/media/left.0e689d58.mp3";